module.exports = __webpack_public_path__ + "img/dui_icon.b6d8fbe9.png";